import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var DeleteIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'sm' : _b;
    var iconSize = {
        sm: {
            width: 12,
            height: 12,
        },
        md: {
            width: 24,
            height: 24,
        },
        lg: {
            width: 30,
            height: 30,
        },
    };
    return (_jsx("svg", { width: iconSize[size].width, height: iconSize[size].height, viewBox: '0 0 9 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M3.6875 0.25H5.3125C5.54948 0.25 5.74414 0.326172 5.89648 0.478516C6.04883 0.630859 6.125 0.825521 6.125 1.0625V1.46875H8.96875V2.28125H8.52441L7.71191 10H1.28809L0.475586 2.28125H0.03125V1.46875H2.875V1.0625C2.875 0.825521 2.95117 0.630859 3.10352 0.478516C3.25586 0.326172 3.45052 0.25 3.6875 0.25ZM3.6875 1.0625V1.46875H5.3125V1.0625H3.6875ZM1.30078 2.28125L2.02441 9.1875H6.97559L7.69922 2.28125H1.30078ZM2.875 3.5H3.6875V7.96875H2.875V3.5ZM4.09375 3.5H4.90625V7.96875H4.09375V3.5ZM5.3125 3.5H6.125V7.96875H5.3125V3.5Z', fill: 'currentColor' }) }));
};
